import { useNavigate } from "react-router-dom";

const LeftIcon = () => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(-1)}
      style={{ cursor: "pointer", filter: "brightness(0.3)" }}
    >
      <svg
        width="30"
        height="23"
        viewBox="0 0 30 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.487977 9.89612C0.175525 10.2087 -5.05191e-07 10.6325 -4.85873e-07 11.0745C-4.66556e-07 11.5164 0.175525 11.9402 0.487977 12.2528L9.91631 21.6811C10.0701 21.8403 10.254 21.9673 10.4573 22.0546C10.6606 22.142 10.8793 22.188 11.1006 22.1899C11.3219 22.1918 11.5414 22.1496 11.7462 22.0658C11.9511 21.982 12.1371 21.8583 12.2936 21.7018C12.4501 21.5453 12.5739 21.3592 12.6577 21.1544C12.7415 20.9496 12.7836 20.7301 12.7817 20.5088C12.7798 20.2875 12.7338 20.0688 12.6465 19.8655C12.5591 19.6621 12.4322 19.4782 12.273 19.3245L5.68964 12.7411L27.7613 12.7411C28.2033 12.7411 28.6273 12.5655 28.9398 12.253C29.2524 11.9404 29.428 11.5165 29.428 11.0745C29.428 10.6324 29.2524 10.2085 28.9398 9.89594C28.6273 9.58338 28.2033 9.40779 27.7613 9.40779L5.68964 9.40779L12.273 2.82444C12.5766 2.5101 12.7446 2.0891 12.7408 1.65211C12.737 1.21511 12.5617 0.797094 12.2527 0.48808C11.9437 0.179067 11.5256 0.00378368 11.0886 -1.38361e-05C10.6516 -0.00381135 10.2306 0.164182 9.91631 0.467779L0.487977 9.89612Z"
          fill="#000000"
        />
      </svg>
    </div>
  );
};

export default LeftIcon;
